function toFixedIfNecessary(value: number, dp: number) {
  console.log(value);
  const calc = +parseFloat(value.toString()).toFixed(dp);
  // if has decimal, use ',' instead of '.'
  if ((calc.toString()).indexOf('.') !== -1) {
    return calc.toString().replace('.', ',');
  }
  return calc;
}

export default toFixedIfNecessary;